import { render, staticRenderFns } from "./ModalInputNickname.vue?vue&type=template&id=708b14ce&scoped=true"
import script from "./ModalInputNickname.vue?vue&type=script&lang=js"
export * from "./ModalInputNickname.vue?vue&type=script&lang=js"
import style0 from "./ModalInputNickname.vue?vue&type=style&index=0&id=708b14ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708b14ce",
  null
  
)

export default component.exports